/* tslint:disable */
import {
  App,
  Paastenant,
  Account
} from '../index';

declare var Object: any;
export interface TenantInterface {
  ownerId: any;
  name: string;
  description: string;
  status: string;
  lastupdatedby?: string;
  createdby?: string;
  id?: any;
  paastenantId?: any;
  createdAt: Date;
  updatedAt: Date;
  apps?: App[];
  paastenant?: Paastenant;
  owner?: Account;
}

export class Tenant implements TenantInterface {
  ownerId: any;
  name: string;
  description: string;
  status: string;
  lastupdatedby: string;
  createdby: string;
  id: any;
  paastenantId: any;
  createdAt: Date;
  updatedAt: Date;
  apps: App[];
  paastenant: Paastenant;
  owner: Account;
  constructor(data?: TenantInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `Tenant`.
   */
  public static getModelName() {
    return "Tenant";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of Tenant for dynamic purposes.
  **/
  public static factory(data: TenantInterface): Tenant{
    return new Tenant(data);
  }  
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'Tenant',
      plural: 'tenants',
      properties: {
        ownerId: {
          name: 'ownerId',
          type: 'any'
        },
        name: {
          name: 'name',
          type: 'string'
        },
        description: {
          name: 'description',
          type: 'string'
        },
        status: {
          name: 'status',
          type: 'string'
        },
        lastupdatedby: {
          name: 'lastupdatedby',
          type: 'string',
          default: 'system'
        },
        createdby: {
          name: 'createdby',
          type: 'string',
          default: 'system'
        },
        id: {
          name: 'id',
          type: 'any'
        },
        paastenantId: {
          name: 'paastenantId',
          type: 'any'
        },
        createdAt: {
          name: 'createdAt',
          type: 'Date'
        },
        updatedAt: {
          name: 'updatedAt',
          type: 'Date'
        },
      },
      relations: {
        apps: {
          name: 'apps',
          type: 'App[]',
          model: 'App'
        },
        paastenant: {
          name: 'paastenant',
          type: 'Paastenant',
          model: 'Paastenant'
        },
        owner: {
          name: 'owner',
          type: 'Account',
          model: 'Account'
        },
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/sdk/models/Tenant.ts